import React, {Component} from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import LoadingDots from "./ui/LoadingDots";
import Select from 'react-select';
import { createForm } from "../actions";
import { setSelectedCompany } from "../actions/auth";
import { getProcessStatus, notify } from './Utils';


class RequestCreate extends Component {

  constructor() {
    super();
    this.onCreate = this.onCreate.bind(this);
  }

  onCreate(form_kind) {
    const selectedCompany = this.props?.selectedCompany?.value;
    let optionalData = {}

    if (this.props.needORN) {
      optionalData = { 
        company_orn: selectedCompany?.company_orn
      }
    }
    
    this.props.createForm({
      form_kind,
      ...optionalData
    });
  }
  // onCreate(event) {
  //   const { forms } = this.props;
  //   const selectedCompany = this.props.selectedCompany.value
  //   let draftExist = false;
  //
  //   for(var f of forms) {
  //     if (getProcessStatus(f) === 'Черновик' && typeof selectedCompany !== 'undefined' && Number(selectedCompany.company_orn) === Number(f.orn)) {
  //       notify(`Для компании ${f.company} уже есть один черновик. Нельзя создавать больше одного черновика на компанию`);
  //       draftExist = true;
  //       this.props.setSelectedCompany(null)
  //     }
  //   }
  //   if (!draftExist) this.props.createForm(selectedCompany.company_orn);
  // }

  render() {
    const { companies, loaders, needORN } = this.props;

    return (
      <LoadingDots show={typeof loaders['companies'] !== 'undefined' || !this.props.modeLoaded}>

        {!needORN && (
            <div className="col-sm-2 col-xs-12 align-items-end d-flex">
              <button type="button" className="btn btn-success btn-sm w-btn" onClick={() => {this.onCreate(24)}}>Создать заявку</button>
            </div>
        )}

        {companies.length === 0 && needORN && (
          <div className='text-block text-block_empty'>
            Не найдено ни одной компании
          </div>
        )}

        {/* если компания у пользователя одна select не показывается */}
        {(companies.length === 1 && needORN) && (
          <div className="col-sm-2 col-xs-12 align-items-end d-flex">
            <button type="button" className="btn btn-success btn-sm w-btn" onClick={() => {this.onCreate(0)}}>Создать заявку</button>
          </div>
        )}

        {(companies.length > 1 && needORN) && (
          <div className="text-block">
            <div className="from-group">
              <div className="input-group row">
                <div className="col-sm-5 col-xs-12">
                  <label>Выберите компанию</label>
                  <Select
                      autosize={false}
                      name="form-field-name"
                      placeholder="Выберите из списка"
                      value={this.props.selectedCompany}
                      style={{borderColor: "#ccc" }} // : "#4eb43e"
                      onChange={value => this.props.setSelectedCompany(value)}
                      options={companies.map(company => ({label: company['company_name'].ru || company['company_name'], value: company}))}
                  />
                </div>
                {this.props.selectedCompany && (
                  <div className="col-sm-2 col-xs-12 align-items-end d-flex">
                    <button type="button" className="btn btn-success btn-sm w-btn" onClick={() => {this.onCreate(0)}}>Создать заявку</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </LoadingDots>
    )
  }
}

RequestCreate.propTypes = {
  companies: PropTypes.array.isRequired,
  loaders: PropTypes.shape({}).isRequired,
  forms: PropTypes.array.isRequired
};

const mapDispatchToProps = {
  createForm,
  setSelectedCompany
};

function mapStateToProps(state) {
  return {
    companies: state.forms.companies,
    selectedCompany: state.forms.selectedCompany,
    loaders: state.forms.loaders,
    forms: state.forms.forms,
    modeLoaded: state.forms.modeLoaded,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCreate);
